import { client } from "../../../api/client";

export const fetchExportTemplate = async () => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return require("./_local/_exportTemplateData.json");
  } else {
    try {
      const response = await client.get(process.env.REACT_APP_GATEWAY_URI, "templatesapi/exporttemplate");
      return response.data;
    } catch (error) {
      console.error("Error fetching export template:", error);
      return [];
    }
  }
}

export const fetchExportTemplateDropdown = async () => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return require("./_local/_exportTemplateData.json");
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, "templatesapi/exporttemplate/dropdown");
            if(response.ok)
                return response.data;
            else {
                console.error("Error getting export template dropdown", response.data);
                return [];
            }
        } catch (error) {
            console.error("Error fetching export template dropdown:", error);
            return [];
        }
    }
}

export const fetchExportTemplateById = async (id) => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return require("./_local/_exportTemplateData.json");
  } else {
    try {
      const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `templatesapi/exporttemplate/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching export template by id:", error);
      return [];
    }
  }
}

export const fetchExportTemplateByFilter = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return require("./_local/_exportTemplateData.json");
  } else {
    try {
      const response = await client.post(process.env.REACT_APP_GATEWAY_URI, "templatesapi/exporttemplate/filter", body);
      return response.data;
    } catch (error) {
      console.error("Error fetching export template by filter:", error);
      return [];
    }
  }
}

export const fetchExportTemplatesToRunOnQuoteCreation = async () => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return require("./_local/_exportTemplateData.json");
  } else {
    try {
      const response = await client.get(process.env.REACT_APP_GATEWAY_URI, "templatesapi/exporttemplate/GetExportTemplatesToRunOnQuoteCreation");
      return response.data;
    } catch (error) {
      console.error("Error fetching export templates to run on quote creation:", error);
      return [];
    }
  }
}

export const createExportTemplate = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
      const response = await client.post(process.env.REACT_APP_GATEWAY_URI, "templatesapi/exporttemplate", body);
      return response.data;
    } catch (error) {
      console.error("Error creating export template:", error);
      return null;
    }
  } else {
    return { "data": { newId: Math.floor(Math.random() * 100000) } };
  }
};

export const deleteExportTemplate = async (id) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
      await client.delete(process.env.REACT_APP_GATEWAY_URI, `templatesapi/exporttemplate/${id}`);
    } catch (error) {
      console.error("Error deleting export template:", error);
    }
  }
};


export const updateExportTemplate = async (id, body) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
      await client.put(process.env.REACT_APP_GATEWAY_URI, `templatesapi/exporttemplate/${id}`, body);
    } catch (error) {
      console.error("Error updating export template:", error);
    }
  }
};

export const exportTemplate = async (body) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") return null;
    try {
        const response = await client.post(
            process.env.REACT_APP_GATEWAY_URI,
            "templatesapi/exporttemplate/exporttemplate",
            body // JSON in
            // If your client supports a 4th options arg and you need it, add:
            // , { responseType: "arraybuffer" }
        );
        // File bytes out – same as exportItems
        console.log("response", response);
        return response.data;
    } catch (error) {
        console.error("Error testing export template:", error);
        return null;
    }
}


export const testExportTemplate = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "true") return null;

  try {
    // Same 3-arg signature your client uses elsewhere
    console.log('testExportTemplate body', body);
    
    const response = await client.post(
      process.env.REACT_APP_GATEWAY_URI,
      "templatesapi/exporttemplate/test",
      body // JSON in
      // If your client supports a 4th options arg and you need it, add:
      // , { responseType: "arraybuffer" }
    );
    // File bytes out – same as exportItems
    return response.data;
  } catch (error) {
    console.error("Error testing export template:", error);
    return null;
  }
};
